export default store => store.data.accounts.items;
